import type { HotelSearchCriteria } from "@/features/hotels/types/types";
import type { HotelSearchFormValues } from "@/features/hotels/utils/hotelsValidation";

export function buildHotelSearchCriteria(
  searchData: HotelSearchFormValues,
): HotelSearchCriteria {
  return {
    destination: searchData.destination?.name,
    travel_date: searchData.dates.checkIn,
    return_date: searchData.dates.checkOut,
    rooms: searchData.rooms,
  };
}
